import React, { useState } from "react";
import LabDetailsPanel from "./LabDetailsPanel";
import EnquiryForm from "../EnquiryForm";
import "./SchoolLabsPanel.css";

const schoolLabs = [
  {
    id: 1,
    name: "STEM Lab",
    icon: "⚙️",
    hasChevron: true,
    cardImage: "/assets/images/stemlab1.png",
    enquiryImage: "/assets/images/stemlab1.png",
    domains: ["STEM", "Science", "Electronics", "Embedded", "IoT"],
    packages: [
      {
        label: "Starter", price: "₹3L", subtitle: "BASIC SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Smart Lab Integration", percent: 40, color: "blue" },
          { label: "STEM Equipment & Arduino Kits", percent: 35, color: "blue" },
          { label: "Curriculum & Training Support", percent: 15, color: "green" },
          { label: "Software & Digital Tools", percent: 5, color: "green" },
          { label: "Installation & Maintenance Support", percent: 5, color: "blue" },
        ],
        total: "₹3 Lakhs",
      },
      {
        label: "Intermediate", price: "₹5L", subtitle: "ADVANCED SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Smart Lab Integration", percent: 40, color: "blue" },
          { label: "STEM Equipment & Arduino Kits", percent: 35, color: "blue" },
          { label: "Curriculum & Training Support", percent: 15, color: "green" },
          { label: "Software & Digital Tools", percent: 5, color: "green" },
          { label: "Installation & Maintenance Support", percent: 5, color: "blue" },
        ],
        total: "₹5 Lakhs",
      },
      {
        label: "Advanced", price: "₹7L", subtitle: "FULL SUITE",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Smart Lab Integration", percent: 40, color: "blue" },
          { label: "STEM Equipment & Arduino Kits", percent: 35, color: "blue" },
          { label: "Curriculum & Training Support", percent: 15, color: "green" },
          { label: "Software & Digital Tools", percent: 5, color: "green" },
          { label: "Installation & Maintenance Support", percent: 5, color: "blue" },
        ],
        total: "₹7 Lakhs",
      },
    ],
  },
  {
    id: 2,
    name: "Robotics Lab",
    icon: "🤖",
    hasChevron: true,
    cardImage: "https://images.unsplash.com/photo-1535378917042-10a22c95931a?w=400&fit=crop",
    enquiryImage: "/assets/images/robotics.png",
    domains: ["STEM", "Science", "Electronics", "Embedded", "IoT", "Robotics"],
    packages: [
      {
        label: "Starter", price: "₹3L", subtitle: "BASIC SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 45, color: "blue" },
          { label: "Robotics Kits & Equipment", percent: 30, color: "blue" },
          { label: "Training & Curriculum", percent: 15, color: "green" },
          { label: "Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance Support", percent: 5, color: "blue" },
        ],
        total: "₹3 Lakhs",
      },
      {
        label: "Intermediate", price: "₹5L", subtitle: "ADVANCED SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 45, color: "blue" },
          { label: "Robotics Kits & Equipment", percent: 30, color: "blue" },
          { label: "Training & Curriculum", percent: 15, color: "green" },
          { label: "Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance Support", percent: 5, color: "blue" },
        ],
        total: "₹5 Lakhs",
      },
      {
        label: "Advanced", price: "₹7L", subtitle: "FULL SUITE",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 45, color: "blue" },
          { label: "Robotics Kits & Equipment", percent: 30, color: "blue" },
          { label: "Training & Curriculum", percent: 15, color: "green" },
          { label: "Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance Support", percent: 5, color: "blue" },
        ],
        total: "₹7 Lakhs",
      },
    ],
  },
  {
    id: 3,
    name: "Innovation Lab",
    icon: "💡",
    cardImage: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?w=400",
    enquiryImage: "/assets/images/innovation10.png",
    domains: ["STEM & Robotics", "AI", "IoT"],
    packages: [
      {
        label: "Starter", price: "₹7L", subtitle: "BASIC SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 40, color: "blue" },
          { label: "Innovation Kits & Equipment", percent: 35, color: "blue" },
          { label: "Curriculum & Training", percent: 15, color: "green" },
          { label: "Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance", percent: 5, color: "blue" },
        ],
        total: "₹7 Lakhs",
      },
      {
        label: "Intermediate", price: "₹10L", subtitle: "ADVANCED SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 40, color: "blue" },
          { label: "Innovation Kits & Equipment", percent: 35, color: "blue" },
          { label: "Curriculum & Training", percent: 15, color: "green" },
          { label: "Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance", percent: 5, color: "blue" },
        ],
        total: "₹10 Lakhs",
      },
      {
        label: "Advanced", price: "₹15L", subtitle: "FULL SUITE",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 40, color: "blue" },
          { label: "Innovation Kits & Equipment", percent: 35, color: "blue" },
          { label: "Curriculum & Training", percent: 15, color: "green" },
          { label: "Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance", percent: 5, color: "blue" },
        ],
        total: "₹15 Lakhs",
      },
    ],
  },
  {
    id: 4,
    name: "ATL Lab",
    icon: "🔬",
    cardImage: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=400",
    enquiryImage: "/assets/images/innovation10.png",
    domains: ["Robotics", "Electronics", "IoT", "3D Printing & Design", "Coding & Programming", "Design Thinking"],
    packages: [
      {
        label: "Starter", price: "₹6L", subtitle: "BASIC SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 40, color: "blue" },
          { label: "ATL Kits & Equipment", percent: 35, color: "blue" },
          { label: "Training & Curriculum", percent: 15, color: "green" },
          { label: "Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance", percent: 5, color: "blue" },
        ],
        total: "₹6 Lakhs",
      },
      {
        label: "Intermediate", price: "₹9L", subtitle: "ADVANCED SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 40, color: "blue" },
          { label: "ATL Kits & Equipment", percent: 35, color: "blue" },
          { label: "Training & Curriculum", percent: 15, color: "green" },
          { label: "Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance", percent: 5, color: "blue" },
        ],
        total: "₹9 Lakhs",
      },
      {
        label: "Advanced", price: "₹14L", subtitle: "FULL SUITE",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab", desc: "Robotics · STEM Kits · Smart Learning Space" },
          { icon: "📚", title: "Training & Curriculum", desc: "STEM · Electronics · IoT · Robotics · AI Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "SIDP · ATL Marathon · WRO · Science Expo" },
          { icon: "🎓", title: "School Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 40, color: "blue" },
          { label: "ATL Kits & Equipment", percent: 35, color: "blue" },
          { label: "Training & Curriculum", percent: 15, color: "green" },
          { label: "Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance", percent: 5, color: "blue" },
        ],
        total: "₹14 Lakhs",
      },
    ],
  },
  {
    id: 5,
    name: "Customised Lab",
    icon: "🎛️",
    isCustom: true,
    cardImage: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&fit=crop",
    enquiryImage: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&fit=crop",
    domains: [],
    packages: [],
  },
];

export default function SchoolLabsPanel({ onClose }) {
  const [selectedLab, setSelectedLab] = useState(null);
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [enquiryLab, setEnquiryLab] = useState(null);

  if (selectedLab) {
    return (
      <LabDetailsPanel
        lab={{ ...selectedLab, image: selectedLab.enquiryImage || selectedLab.cardImage }}
        onBack={() => setSelectedLab(null)}
        onClose={onClose}
      />
    );
  }

  return (
    <>
      <div className="school-panel">
        <div className="panel-header">
          <div className="panel-title">
            <span className="dot" />
            <h2>School Lab Solutions</h2>
          </div>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="labs-grid">
          {schoolLabs.map((lab) => (
            <div
              key={lab.id}
              className={`lab-card ${lab.isCustom ? "lab-card--custom" : ""}`}
              onClick={() => !lab.isCustom && setSelectedLab(lab)}
            >
              <div className="lab-img">
                <img src={lab.cardImage} alt={lab.name} />
                <div className="lab-icon">{lab.icon}</div>
              </div>

              <div className="lab-body">
                <div className="lab-name-row">
                  <h4>{lab.name}</h4>
                  {lab.hasChevron && <span className="chevron">∨</span>}
                </div>

                {lab.isCustom ? (
                  <div className="dream-box">
                    <div className="dream-box-header">
                      <span className="dream-icon">🎯</span>
                      <strong>Build Your Dream Lab</strong>
                    </div>
                    <p className="dream-subtitle">
                      Tailored to your space, curriculum &amp; goals
                    </p>
                    <div className="starting-from">STARTING FROM</div>
                  </div>
                ) : (
                  <>
                    <p className="domain-title">
                      <span className="domain-icon">≡</span> DOMAINS INCLUDES
                    </p>
                    <div className="tags">
                      {lab.domains.map((d) => (
                        <span key={d} className="tag">○ {d}</span>
                      ))}
                    </div>
                  </>
                )}

                <button
                  className="view-btn"
                  onClick={
                    lab.isCustom
                      ? (e) => {
                          e.stopPropagation();
                          setEnquiryLab(lab);
setShowEnquiry(true);
                        }
                      : undefined
                  }
                >
                  <span className="view-btn-left">
                    <span className="view-btn-icon">
                      {lab.isCustom ? "✉" : "≡"}
                    </span>
                    {lab.isCustom ? "ENQUIRE NOW" : "VIEW PACKAGES"}
                  </span>
                  <span className="btn-arrow">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showEnquiry && enquiryLab && (
        <EnquiryForm
          labName={enquiryLab.name}
          labImage={enquiryLab.enquiryImage}
          onClose={() => {
            setShowEnquiry(false);
            setEnquiryLab(null);
          }}
        />
      )}
    </>
  );
}